import { createAction } from '@reduxjs/toolkit';
import { SetJackpotPayload } from './types';

export const setJackpot = createAction<SetJackpotPayload>('app/jackpot/set');
